import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../../common/helpers/helpers";

const EvidenceColumn = ({ evidenceIds }) => {
  if (evidenceIds && evidenceIds.length > 0) {
    return (
      <>
        {evidenceIds.map((id, i) => {
          return (
            <span key={i} className="tw-mb-0">
              <a
                href={getVarsoUrl(
                  `https://civicdb.org/evidence/${id}/summary/`
                )}
                target="_blank"
              >
                {id}
              </a>
              {i === evidenceIds.length - 1 ? null : <span>, </span>}
            </span>
          );
        })}
      </>
    );
  }
  return "-";
};

EvidenceColumn.propTypes = {
  evidenceIds: PropTypes.arrayOf(PropTypes.number),
};

EvidenceColumn.defaultProps = {
  evidenceIds: [],
};

export default EvidenceColumn;
